import AuthLayout from '@/components/Layout/AuthLayout'
import { Button, Flex, Heading, VStack } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { APP_MODE } from '@/config'
import config from '@/config'

const NotFoundPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const isProduction = config.mode == APP_MODE.PRODUCTION

  return (
    <AuthLayout title={'Not Found'}>
      <VStack h="100vh" w="100vw" role="alert" justifyContent="center" alignItems="center" spacing="20px">
        <Heading size="lg" color={'white'}>
          {t('NOT_FOUND_PAGE_WARNING')}
        </Heading>
        <Flex w="200px">
          <Button colorScheme="blue" onClick={() => navigate(isProduction ? '/auth/login' : '/external/auth/login')}>
            {t('NOT_FOUND_PAGE_REDIRECT')}
          </Button>
        </Flex>
      </VStack>
    </AuthLayout>
  )
}

export default NotFoundPage
